import { Type } from '@angular/core';
import { lazyChunk } from '../routing/lazy-chunk';

export const modalRegistry: Record<string, () => Promise<Type<any>>> = {
  MapRedirectModal: lazyChunk(
    () => import('../../user/map-redirect-modal/map-redirect-modal.component'),
    (m) => m.MapRedirectModalComponent
  ),
  SubscriptionConfirmationModal: lazyChunk(
    () =>
      import(
        '../../user/user/subscriptions-menu/subscription-confirmation-modal/subscription-confirmation-modal.component'
      ),
    (m) => m.SubscriptionConfirmationModalComponent
  ),
  SubscriptionRenewalModal: lazyChunk(
    () =>
      import(
        '../../user/user/subscriptions-menu/subscription-confirmation-modal/subscription-renewal-modal/subscription-renewal-modal.component'
      ),
    (m) => m.SubscriptionRenewalModalComponent
  ),
  SetRadiusModal: lazyChunk(
    () => import('../components/set-radius-modal/set-radius-modal.component'),
    (m) => m.SetRadiusModalComponent
  ),
  HelpAndFeedbackModal: lazyChunk(
    () =>
      import(
        '../../shared/components/help-and-feedback-modal/help-and-feedback-modal.component'
      ),
    (m) => m.HelpAndFeedbackModalComponent
  ),
  SubscriptionPlansModal: lazyChunk(
    () =>
      import(
        '../../shared/components/subscription-plans-modal/subscription-plans-modal.component'
      ),
    (m) => m.SubscriptionPlansModalComponent
  ),
  RecommendedSubscriptionModal: lazyChunk(
    () =>
      import(
        '../../shared/components/recommended-subscription-modal/recommended-subscription-modal.component'
      ),
    (m) => m.RecommendedSubscriptionModalComponent
  ),
  AuthModal: lazyChunk(
    () => import('../../user/auth-modal/auth-modal.component'),
    (m) => m.AuthModalComponent
  ),
};
